import React from "react";
import { useSearchParams } from "react-router-dom";
import { cadastrarUsuarioRevenda } from "../services/api";
import CadastroRevendaUsuario from "./CadastroRevendaUsuario";

const NovoRevendaUsuario = ({ token }) => {
  const [searchParams] = useSearchParams();
  const revendaId = searchParams.get("revendaId") || "";

  const handleCreateSubmit = async (data, token) => {
    await cadastrarUsuarioRevenda(data, token);
  };

  return (
    <CadastroRevendaUsuario
      token={token}
      onSubmit={handleCreateSubmit}
      isEdit={false}
      revendaIdFromQuery={revendaId}
    />
  );
};

export default NovoRevendaUsuario;
